import { useMutation } from "react-query";
import { uploadInventoryExcel } from "@/api/Implementation/initialLoad";

// const key = "implementation";

export function useUploadInventoryExcel() {
	return useMutation({
		mutationFn: async (formData) => await uploadInventoryExcel(formData),
	});
}
